import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAddressesSWR from '../../hooks/addresses/useAddresses';
import useFullScreenLoading from '../../hooks/useFullScreenLoading';
import useProfileEditorDialog from '../../hooks/useProfileEditorDialog';
import { AddressResp } from '../../models/Addresses';
import { AddressesLoadingLayout } from '../layouts/LoadingLayouts/AddressesLoadingLayout';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import { ErrorTypography } from '../styled/ErrorTypography';
import { AddressItem } from './AddressItem';

export const AddressesContent = () => {
    const { addresses, isLoading, isError, forceRefresh } = useAddressesSWR();
    const { t } = useTranslation();
    const profileDialog = useProfileEditorDialog();
    const fullScreenLoading = useFullScreenLoading();

    const openNewAddressDialog = () => {
        profileDialog.showAddressesEditor(true);
    };

    const handleForceRefresh = () => {
        fullScreenLoading.setFullScreenLoading(true);
        profileDialog.setAddressDialogClosedWithSuccess(false);
        forceRefresh().finally(() => {
            fullScreenLoading.setFullScreenLoading(false);
        });
    };

    useEffect(() => {
        if (profileDialog.addressDialogClosedWithSuccess) {
            handleForceRefresh();
        }
    }, [profileDialog.addressDialogClosedWithSuccess]);

    return (
        <Box>
            <Box sx={{ padding: '10px 0' }}>
                <Typography variant="h2">
                    {t('PROFILE.ADDRESS_CONTENT.TITLE')}
                </Typography>
            </Box>
            {isLoading && <AddressesLoadingLayout />}
            {isError && <ErrorTypography errorCode={'ADDRESSES_NOT_LOADED'} />}
            {!isLoading && !isError && (
                <>
                    {addresses.map((address: AddressResp) => (
                        <AddressItem
                            key={address.id}
                            address={address}
                            handleChange={handleForceRefresh}
                        />
                    ))}

                    <Box sx={{ paddingTop: '24px' }}>
                        <PrimaryBtn onClick={openNewAddressDialog}>
                            {t('PROFILE.ADDRESS_CONTENT.ADD_NEW')}
                        </PrimaryBtn>
                    </Box>
                </>
            )}
        </Box>
    );
};
